import { SectionHeading } from "./SectionHeading";
import { community } from "../../data/portfolioData";

export const CommunitySection = () => {
    return (
        <section
            id="community"
            data-testid="community-section"
            className="relative scroll-mt-24 px-6 py-24 md:px-12 md:py-32 lg:px-16"
        >
            <div className="mx-auto max-w-7xl">
                <SectionHeading
                    index="06"
                    kicker="Community · Open source"
                    title="Lowering the fear around tech."
                    subtitle="I care about technical communities that make beginners feel welcome — student programs, contribution drives, hackathon mentoring, and FOSS work."
                />

                <ol className="relative ml-2 border-l border-[var(--ink-border)]">
                    {community.map((c, idx) => (
                        <li
                            key={c.title}
                            data-testid={`community-item-${idx}`}
                            className="group relative pb-10 pl-8 last:pb-0"
                        >
                            <span className="absolute -left-[6px] top-1.5 inline-flex h-3 w-3 items-center justify-center rounded-full border border-[var(--ink-border-strong)] bg-[var(--ink-bg)] transition-colors group-hover:border-ink-cyan group-hover:bg-ink-cyan/20">
                                <span className="h-1.5 w-1.5 rounded-full bg-ink-cyan" />
                            </span>
                            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-text-secondary)]">
                                {String(idx + 1).padStart(2, "0")} ·
                                contribution
                            </div>
                            <h3 className="mt-1 text-base font-medium text-[var(--ink-text-primary)] md:text-lg">
                                {c.title}
                            </h3>
                            <p className="mt-1 max-w-2xl text-sm leading-relaxed text-[var(--ink-text-secondary)]">
                                {c.description}
                            </p>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
};

export default CommunitySection;
